// extracted by mini-css-extract-plugin
export default {"savedLabel":"savedLabel__WZG9J8"};